import React, { Component, createRef } from 'react'
import { findDOMNode } from 'react-dom'
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { DragSource, DropTarget } from 'react-dnd'
import { flow } from 'lodash'

const Item = flow(
	DragSource(
		'item',
		// (props) => props.type /*  || 'item' */,
		{
			beginDrag(props) {
				return {
					id: props.id,
					index: props.index,
					item: props.item,
					idx: props.idx,
				}
			},
		},
		(connect, monitor) => ({
			connectDragSource: connect.dragSource(),
			connectDragPreview: connect.dragPreview(),
			isDragging: monitor.isDragging(),
		}),
	),
	DropTarget(
		['item', 'sectionPill'],
		// (props) => props.accepts /*  || [props?.type] || ['item'] */,
		{
			drop(props, monitor) {
				const itemType = monitor.getItemType()
				if (props?.accepts?.includes?.(itemType) && props?.onDrop) {
					props.onDrop(monitor.getItem(), props.item, props.index)
				}
			},
			hover(props, monitor, component) {
				const itemType = monitor.getItemType()

				if (itemType === props.type || (!props?.type && itemType === 'item')) {
					const dragIndex = monitor.getItem().index
					const hoverIndex = props.index
					if (dragIndex === hoverIndex) {
						return
					}
					const hoverBoundingRect =
						findDOMNode(component).getBoundingClientRect()
					const hoverMiddleY =
						(hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
					const clientOffset = monitor.getClientOffset()
					const hoverClientY = clientOffset.y - hoverBoundingRect.top
					if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
						return
					}
					if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
						return
					}
					Promise.resolve(props.moveItem(dragIndex, hoverIndex))
					monitor.getItem().index = hoverIndex
				}

				// if (props?.accepts?.includes?.(itemType)) {
				// 	console.log('hover')
				// 	console.log(props.index)
				// }
			},
		},
		(connect, monitor) => ({
			connectDropTarget: connect.dropTarget(),
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop(),
			didDrop: monitor.didDrop(),
		}),
	),
)(
	class ItemUIComponent extends Component {
		constructor(props) {
			super(props)
			this.myRef = createRef()
			this.state = {
				typing: false,
				anchorEl: null,
				// mouseDown: false,
			}
		}

		render() {
			const {
				isOver,
				id,
				connectDropTarget,
				connectDragSource,
				connectDragPreview,
				isDragging,
				ItemUI,
				item,
				index,
				onDelete,
				DragHandle,
				moveUp,
				moveDown,
			} = this.props

			return DragHandle
				? connectDropTarget(
						connectDragPreview(
							<div
								ref={this.myRef}
								className="sortableItem"
								style={{ transform: 'translate(0,0)', position: 'relative' }}
							>
								{connectDragSource(
									<div
										style={{
											position: 'absolute',
											left: 0,
											top: '50%',
											transform: 'translate(0, -50%)',
											zIndex: 1,
											display: isDragging || isOver ? 'none' : undefined,
										}}
									>
										<DragHandle />
									</div>,
								)}
								<ItemUI
									moveUp={moveUp}
									moveDown={moveDown}
									isOver={isOver}
									item={item}
									isDragging={isDragging}
									id={id}
									index={index}
									onDelete={onDelete}
									height={this.myRef?.current?.clientHeight}
								/>
							</div>,
						),
				  )
				: connectDragSource(
						connectDropTarget(
							<div ref={this.myRef} style={{ transform: 'translate(0, 0)' }}>
								<ItemUI
									moveUp={moveUp}
									moveDown={moveDown}
									isOver={isOver}
									item={item}
									isDragging={isDragging}
									id={id}
									index={index}
									onDelete={onDelete}
									height={this.myRef?.current?.clientHeight}
								/>
							</div>,
						),
				  )
		}
	},
)

export default Item
